<!--信用评级-->
<template>
<div class="rating-container">
  <header-index/>
  <div class="rating-content">
    <div class="rating-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
          {{ cityList.abridge }}企服务云
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
        <el-breadcrumb-item>税务评级</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="rating-top">
      <p class="rating-title">查询税务评级</p>
      <el-input placeholder="请输入企业名称、组织机构代码" v-model="keyword" class="input-with-select" style="width: 45%;"
                @keyup.enter.native="getCreditRatingInfo">
        <el-button type="danger" slot="append" @click="getCreditRatingInfo">查一下</el-button>
      </el-input>
    </div>
    <div class="rating-info">
      <div class="rating-search-menu">
        <span>最新税务评级</span>
        <div>
          <el-select v-model="region" placeholder="请选择" style="width: 170px;margin-right: 20px" clearable>
            <el-option :label="'全国'" :value="''"/>
            <el-option v-for="item in provincialCode" :label="item.name" :value="item.code"/>
          </el-select>
          <el-select v-model="creditRating" placeholder="税务评级" style="width: 170px;margin-right: 20px" clearable>
            <el-option v-for="item in creditRatingType" :label="item.name" :value="item.name"/>
          </el-select>
          <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份不限" style="width: 170px"/>
        </div>
      </div>
      <div class="rating-list" v-if="tablePage.total>0">
        <div v-for="info of creditRatingInfo" class="rating-list-item">
          <p class="rating-small-title">{{ info.companyName }}</p>
          <p>
            <!--纳税信用级别共 A、B、M、C、D 五级-->
            <span class="rating-gray">主体评级：</span>
            <span class="rating-black">{{ info.creditRating }}</span>
            <span class="rating-gray">评级机构：</span>
            <span class="rating-black">{{ info.evaluationUnit }}</span>
            <span class="rating-gray">评级时间：</span>
            <span class="rating-black">{{ info.year }}</span>
          </p>
        </div>
      </div>
      <div v-else>
        <el-empty description="暂无内容"/>
      </div>
      <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
            :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
    </div>
  </div>
  <home_footer/>
  <Hang/>
</div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import page from "@/components/page/pages";
import cityJson from "@/static/cityJson.json";
import {creditRating,getCreditRating,getTaxRatingRegion} from '@/api/enterprise_searchApi'
export default {
  name: "creditRating",
  components: {Hang, Home_footer, HeaderIndex,page},
  data(){
    return{
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      region: '',
      cityJson: cityJson,
      provincialCode: [],
      creditRatingType:[],
      creditRating:'',
      creditRatingInfo:[],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCreditRatingInfo();
      }
    },
    region(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCreditRatingInfo();
      }
    },
    creditRating(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCreditRatingInfo();
      }
    },
  },
  methods:{
    /*获取税务评级*/
    getCreditRatingInfo(){
      creditRating({
        keyword:this.keyword,
        region:this.region | 0,
        creditRating:this.creditRating,
        year:this.year,
        page:this.tablePage.currentPage,
        request:'form'
      }).then(res=>{
        if (res.code==200){
          console.log(res);
          this.creditRatingInfo=res.content.rows;
          this.tablePage.total=parseInt(res.content.total);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.getCreditRatingInfo();
    },
    /*信用级别*/
    getCreditRatingData(){
      getCreditRating().then(res=>{
        if (res.code==200){
          this.creditRatingType=res.content;
        }
      })
    },
    /*地域分组*/
    getRatingRegion(){
      getTaxRatingRegion().then(res=>{
        if (res.code==200){
          this.provincialCode=res.content;
        }
      })
    }
  },
  mounted() {
    this.getCreditRatingData();
    this.getRatingRegion();
    this.getCreditRatingInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')){
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name){
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.rating-container >>> .rating-content .rating-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}

.rating-container >>> .rating-content .rating-top input::-webkit-input-placeholder {
  color: #333333;
}

.rating-container >>> .rating-content .rating-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.rating-container >>> .rating-content .rating-top .el-icon-search {
  font-size: 19px;
}

.rating-container >>> .rating-content .rating-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}

.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__inner a,
.rating-container >>> .rating-content .rating-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.rating-container >>> .rating-content .rating-info .rating-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
</style>
<style scoped lang="scss">
.rating-container{
  background: #E7E9F5;
  .rating-content{
    .rating-breadcrumb {
      padding: 10px 18%;
      background: #E7E9F5;
      min-width: 76rem;
    }

    .rating-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .rating-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }

    .rating-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .rating-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .rating-list {
        .rating-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .rating-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .rating-gray {
            color: #999999;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .rating-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
            padding-right: 50px;
          }
          .rating-120{
            min-width: 120px;
            display: inline-block;
          }
          .rating-200{
            min-width: 200px;
            display: inline-block;
          }
          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>